import { render, staticRenderFns } from "./hazopDashboard copy.vue?vue&type=template&id=5eba5fe2&scoped=true"
import script from "./hazopDashboard copy.vue?vue&type=script&lang=js"
export * from "./hazopDashboard copy.vue?vue&type=script&lang=js"
import style0 from "./hazopDashboard copy.vue?vue&type=style&index=0&id=5eba5fe2&lang=sass"
import style1 from "./hazopDashboard copy.vue?vue&type=style&index=1&id=5eba5fe2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eba5fe2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5eba5fe2')) {
      api.createRecord('5eba5fe2', component.options)
    } else {
      api.reload('5eba5fe2', component.options)
    }
    module.hot.accept("./hazopDashboard copy.vue?vue&type=template&id=5eba5fe2&scoped=true", function () {
      api.rerender('5eba5fe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/processRam/hazopDashboard copy.vue"
export default component.exports